<template>
  <section class="enrolment-congratulations">
    <header class="enrolment-congratulations__header">
      <span class="enrolment-congratulations__icon" aria-hidden="true">
        <img src="~/images/check-fill.svg" class="icon" v-svg-inline>
      </span>
      <div>
        <p class="enrolment-congratulations__caption">Поздравляем с зачислением</p>
        <h3>Дорогой студент!</h3>
      </div>
    </header>

    <div class="enrolment-congratulations__body">
      <p>Факультет дистанционного обучения (ФДО) ТУСУР поздравляет Вас с поступлением!</p>
      <p>
        Обучение будет проходить с применением дистанционных образовательных технологий,
        доступ в личный кабинет студента организован на сайте ФДО ТУСУР:
        <a href="https://fdo.tusur.ru" target="_blank" rel="noopener noreferrer">fdo.tusur.ru</a>.
      </p>
      <p>
        Данные для входа в личный кабинет студента ФДО ТУСУР в ближайшее время будут
        направлены на Вашу электронную почту.
      </p>
      <p>
        Искренне надеемся, что наши совместные усилия позволят стать Вам высококлассным
        специалистом в выбранной Вами сфере деятельности и быть успешным и
        конкурентоспособным в современном мире.
      </p>
    </div>

    <footer class="enrolment-congratulations__footer">
      <p>
        С уважением,<br>
        <strong>деканат ФДО ТУСУР</strong>
      </p>

      <address class="enrolment-congratulations__contacts">
        <a href="tel:+73822701510">+7 (3822) 701-510</a>
        <a href="mailto:dekanat@fdo.tusur.ru">dekanat@fdo.tusur.ru</a>
      </address>
    </footer>
  </section>
</template>
